import Vue from 'vue';
import Slick from 'vue-slick';

function initVueInstance(element) {
    new Vue({
        el: element,

        delimiters: ['${', '}'],

        components: {
            Slick
        },

        data: {
            slickOptions: {
                slidesToShow: 3,
                arrows: false,
                dots: false,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        autoplay:true,
                        fade: true,
                        speed: 100,
                    }
                }]
            }
        }
    });
}

const selectPromoBar = () => document.querySelectorAll('[vue-init-promo-bar-slider]').forEach(element => {
    initVueInstance(element);
});
selectPromoBar();

document.addEventListener("shopify:section:load", function() {
    selectPromoBar();
 });
